import { render, staticRenderFns } from "./ModifyPassword.vue?vue&type=template&id=5c62ecd1&scoped=true"
import script from "./ModifyPassword.vue?vue&type=script&lang=js"
export * from "./ModifyPassword.vue?vue&type=script&lang=js"
import style0 from "./ModifyPassword.vue?vue&type=style&index=0&id=5c62ecd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c62ecd1",
  null
  
)

export default component.exports